import { ModalConfig } from '@shared/interfaces/modal/modal-config';
import {
  MeterReplaceModalComponent
} from '@shared/modals/meter/meter-replace-modal/meter-replace-modal.component';

export const meterReplaceModalConfig: ModalConfig = {
  component: MeterReplaceModalComponent,
  title: 'meter.replaceAttach.replace.title',
  size: 'xl',
  actions: [
    {
      type: 'secondary',
      label: 'system.button.cancel',
      closeOnClick: true
    },
  ],
}
